import { render, staticRenderFns } from "./ModalAddAccount.vue?vue&type=template&id=2b1f8868&"
import script from "./ModalAddAccount.vue?vue&type=script&lang=js&"
export * from "./ModalAddAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports